import styled from 'styled-components';

import { Panel } from '../commonStyles';

export const TotalNetDownPaymentPanel = styled(Panel)`
  margin-bottom: 20px;
`;
